import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { Checkbox, WhiteSpace } from 'antd-mobile'
import { Radio } from 'antd'
import Header from '../../components/common/FormHeader'
import DiverInfo from './DiverInfo'
import CdInfo from './CdInfo'
import StoreInfo from './StoreInfo'
import CheckAge from './CheckAge'
import AddressAndLangOption from '../../components/common/AddressAndLangOption'
import CheckCertsConditions from './CheckCertsConditions'
import Signature from '../../components/common/Signature'
import { getAge, showModal } from '../../components/common/utils'
import OwsiApplicationStatus from './OwsiApplicationStatus'
import UploadOssFile from '../../components/common/UploadOssFile'
import CardLayout from '../../components/common/CardLayout'
import Agreement from './Agreement'
import PickerComponent from '../../components/common/Picker'
import DatePickerComponent from '../../components/common/DatePicker'
import IESelecter from './IESelecter'
import { findEfriCert } from '../../components/common/findCerts'
import Notification from '../../components/Notification'
import AutoRenewCheckbox from '../../components/common/AutoRenewCheckbox'

const CheckboxItem = Checkbox.CheckboxItem

const OwsiApplication = () => {
  const { userInfo, owsiDetail, certifications, credentials, ieList } = useSelector((state) => ({
    userInfo: state.data.userInfo,
    owsiDetail: state.owsi.applicantDetail,
    certifications: state.data.certifications,
    credentials: state.data.credentials,
    ieList: state.owsi.ieList,
  }))
  const { formatMessage } = useIntl()

  const [certStatus, setCertStatus] = useState({
    ow: false,
    aow: false,
    efr: false,
    rescue: false,
    aidm: false,
  })
  const updateCertStatus = (update) => setCertStatus({ ...certStatus, ...update })

  const [checkAge, setCheckAge] = useState(false)
  const [ieListPicker, setIeList] = useState([])
  const [checked, setChecked] = useState(false)
  const [isAutoRenewChecked, setIsAutoRenewChecked] = useState(false)
  const [isAutoRenewJump, setIsAutoRenewJump] = useState(false)
  const [showDialog, setDialogStatus] = useState(false)
  const [formData, setFormData] = useState({
    aidmfiles: [],
    alternateLocation: '',
    aowfiles: [],
    cdinstructorNumber: '',
    code: 0,
    regionId: '',
    efrfiles: [],
    languageId: '',
    owfiles: [],
    rescuefiles: [],
    storeNumber: '',
    storeType: '',
    aidm: '',
    ow: '',
    aow: '',
    rescue: '',
    efr: '',
    ieId: '',
    ieAttempt: 1,
    ieExamModules: [],
    efri: false,
    otherFiles: [],
    heathFiles: [],
    q1: '',
    q2: '',
  })

  const updateFormData = (update) => setFormData({ ...formData, ...update })

  const handleJumpChange = (isAutoRenewJump) => {
    setIsAutoRenewJump(isAutoRenewJump)
  }

  useEffect(() => {
    if (owsiDetail && certifications && credentials) {
      setFormData({
        aidmfiles: owsiDetail.aidmfiles,
        alternateLocation: formData.alternateLocation ? formData.alternateLocation : owsiDetail.alternateLocation,
        aowfiles: owsiDetail.aowfiles,
        cdinstructorNumber: formData.cdinstructorNumber ? formData.cdinstructorNumber : owsiDetail.cdinstructorNumber,
        code: owsiDetail.code,
        regionId: owsiDetail.regionId ? owsiDetail.regionId : formData.regionId,
        efrfiles: owsiDetail.efrfiles,
        languageId: owsiDetail.languageId ? owsiDetail.languageId : formData.languageId,
        owfiles: owsiDetail.owfiles,
        rescuefiles: owsiDetail.rescuefiles,
        storeNumber: formData.storeNumber ? formData.storeNumber : owsiDetail.storeNumber,
        storeType: formData.storeType ? formData.storeType : owsiDetail.storeType,
        aidm: findCert('AI/DM') ? `AI/DM` : '',
        ow: findCert('OW') ? findCert('OW').studentNumber : '',
        aow: findCert('AOW') ? findCert('AOW').studentNumber : '',
        rescue: findCert('RESCUE') ? findCert('RESCUE').studentNumber : '',
        efr: findCert('EFR') ? findCert('EFR').studentNumber : '',
        ieId: owsiDetail.ieId ? owsiDetail.ieId : formData.ieId,
        ieAttempt: owsiDetail.ieAttempt ? owsiDetail.ieAttempt : formData.ieAttempt,
        ieExamModules: owsiDetail.ieExamModules ? owsiDetail.ieExamModules : formData.ieExamModules,
        efri: findEfriCert(credentials) ? true : false,
        otherFiles: owsiDetail.otherFiles || [],
        heathFiles: owsiDetail.heathFiles || [],
        q1: owsiDetail.q1,
        q2: owsiDetail.q2,
      })
    }
  }, [owsiDetail, certifications, credentials])

  useEffect(() => {
    if (ieList.length > 0) {
      const ieListMapping = ieList.map((item) => {
        return {
          label: `${item.location}  ${item.ieDate}`,
          value: item.id,
        }
      })
      setIeList(ieListMapping)
    }
  }, [ieList])

  useEffect(() => {
    if (userInfo) {
      setCheckAge(getAge(userInfo.birthDate) >= 18)
    }
  }, [userInfo])

  useEffect(() => {
    if (owsiDetail && owsiDetail.note) {
      if (!showDialog) {
        showModal(
          formatMessage({ id: 'cardOptions-replaceCardHint' }),
          `${formatMessage({ id: 'dm-app-not-approved-tips' })}${owsiDetail.note}`,
          () => {},
          () => {},
          formatMessage({ id: 'common-comfirmBtn' }),
          formatMessage({ id: 'common-cancel' })
        )
      }
      setDialogStatus(true)
    }
  }, [owsiDetail, formatMessage, showDialog])

  const findCert = (type) => {
    switch (type) {
      case 'OW':
        return certifications.find((item) => item.certificationNumber === 75)
      case 'AOW':
        return certifications.find((item) => item.certificationNumber === 26)
      case 'RESCUE':
        return certifications.find((item) => item.certificationNumber === 72)
      case 'EFR':
        return certifications.find((item) => {
          return (
            !item.expired &&
            (item.certificationNumber === 76 ||
              item.certificationNumber === 68 ||
              item.certificationNumber === 31 ||
              item.certificationNumber === 20)
          )
        })
      case 'AI/DM':
        return credentials.find(
          (item) => item.credentialNumber === 25 || item.credentialNumber === 23 || item.credentialNumber === 6092
        )
      default:
        return null
    }
  }

  const checkCertStatus = () => {
    const { ow, aow, efr, rescue, aidm } = certStatus
    return (
      ow &&
      aow &&
      (efr || formData.efri) &&
      rescue &&
      aidm &&
      // formData.otherFiles.length > 0 &&
      formData.heathFiles.length > 0
    )
  }

  const isFormEditable = () =>
    owsiDetail.status === 'ADMIN_NOT_APPROVED' ||
    !owsiDetail.status ||
    owsiDetail.status === 'SUBMIT' ||
    owsiDetail.status === 'INSTRUCTOR_NOT_APPROVED'

  const renderQuestion = (questionId, title, options, value, onChange) => {
    return (
      <>
        <CardLayout title={<FormattedMessage id={title} />} status="none" style={{ margin: '0 15px' }}>
          <div
            style={{
              padding: '0 10px',
              width: '100%',
            }}
          >
            <Radio.Group
              value={value}
              onChange={(e) => onChange(e.target.value)}
              disabled={!isFormEditable()}
              style={{ width: '100%' }}
            >
              {options.map((option, index) => (
                <Radio
                  key={`${questionId}-option-${index}`}
                  value={option.value}
                  id={`${questionId}-${option.value}`}
                  style={{
                    padding: '8px 0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    width: '100%',
                    cursor: 'pointer',
                  }}
                >
                  <span
                    style={{
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                      cursor: 'pointer',
                      lineHeight: '1.5',
                      marginLeft: '8px',
                    }}
                  >
                    <FormattedMessage id={option.labelId} />
                  </span>
                </Radio>
              ))}
            </Radio.Group>
          </div>
        </CardLayout>
        <WhiteSpace />
      </>
    )
  }

  const q1Options = [
    { value: 'Q1-1', labelId: 'owsi-Q1-1' },
    { value: 'Q1-2', labelId: 'owsi-Q1-2' },
    { value: 'Q1-3', labelId: 'owsi-Q1-3' },
  ]

  const q2Options = [
    { value: 'Q2-1', labelId: 'owsi-Q2-1' },
    { value: 'Q2-2', labelId: 'owsi-Q2-2' },
    { value: 'Q2-3', labelId: 'owsi-Q2-3' },
    { value: 'Q2-4', labelId: 'owsi-Q2-4' },
    { value: 'Q2-5', labelId: 'owsi-Q2-5' },
    { value: 'Q2-6', labelId: 'owsi-Q2-6' },
    { value: 'Q2-7', labelId: 'owsi-Q2-7' },
    { value: 'Q2-8', labelId: 'owsi-Q2-8' },
    { value: 'Q2-9', labelId: 'owsi-Q2-9' },
    { value: 'Q2-10', labelId: 'owsi-Q2-10' },
    { value: 'Q2-11', labelId: 'owsi-Q2-11' },
    { value: 'Q2-12', labelId: 'owsi-Q2-12' },
    { value: 'Q2-13', labelId: 'owsi-Q2-13' },
    { value: 'Q2-14', labelId: 'owsi-Q2-14' },
    { value: 'Q2-15', labelId: 'owsi-Q2-15' },
    { value: 'Q2-16', labelId: 'owsi-Q2-16' },
  ]

  return userInfo && owsiDetail ? (
    <>
      <Notification position="MEMBER_APP" />
      <Header text={<FormattedMessage id="profile-owsi" />} code={owsiDetail.code} />
      <DiverInfo userInfo={userInfo} />
      <WhiteSpace />
      <IESelecter
        resitList={formData.ieExamModules}
        editable={isFormEditable()}
        ieAttempt={formData.ieAttempt}
        updateFormData={updateFormData}
      />
      <WhiteSpace />
      <CdInfo
        cdInfo={owsiDetail ? owsiDetail.cdinfoDTO : {}}
        editable={isFormEditable()}
        setFormData={updateFormData}
        cdinstructorNumber={formData.cdinstructorNumber}
      />
      <WhiteSpace />
      <StoreInfo
        storeType={owsiDetail.storeType}
        storeInfo={owsiDetail.storeInfoDTO}
        updateFormData={updateFormData}
        editable={isFormEditable()}
        storeNumber={formData.storeNumber}
        alternateLocation={formData.alternateLocation}
      />
      <WhiteSpace />
      <CheckAge checkAge={checkAge} />
      <WhiteSpace />
      <CheckCertsConditions
        aidmfiles={formData.aidmfiles}
        aowfiles={formData.aowfiles}
        efrfiles={formData.efrfiles}
        owfiles={formData.owfiles}
        heathFiles={formData.heathFiles}
        otherFiles={formData.otherFiles}
        rescuefiles={formData.rescuefiles}
        certStatus={checkCertStatus()}
        updateCertStatus={updateCertStatus}
        editable={isFormEditable()}
      />
      <WhiteSpace />
      <AddressAndLangOption
        onValueChange={updateFormData}
        languageId={formData.languageId}
        regionId={formData.regionId}
        editable={isFormEditable()}
      />
      <WhiteSpace />
      <PickerComponent
        title={formatMessage({ id: 'owsi-selected-ie' })}
        data={ieListPicker}
        disabled={!isFormEditable()}
        onOk={(id) => updateFormData({ ieId: parseInt(id) })}
        value={formData.ieId}
      >
        <FormattedMessage id="owsi-ie-list" />
      </PickerComponent>
      <WhiteSpace />
      {owsiDetail.trainingRecord && owsiDetail.trainingRecord.length > 0 && (
        <CardLayout title={formatMessage({ id: 'owsi-training-records' })} status={'none'}>
          <UploadOssFile fileList={owsiDetail.trainingRecord} editable={false} type={'OWSI'} />
        </CardLayout>
      )}
      <WhiteSpace />
      {owsiDetail.idcdate && (
        <DatePickerComponent
          disabled={true}
          title={formatMessage({ id: 'setProfile-chooseDate' })}
          value={owsiDetail.idcdate}
        >
          <FormattedMessage id="owsi-idc-date" />
        </DatePickerComponent>
      )}
      {owsiDetail.idcendDate && (
        <DatePickerComponent
          disabled={true}
          title={formatMessage({ id: 'setProfile-chooseDate' })}
          value={owsiDetail.idcendDate}
        >
          <FormattedMessage id="owsi-idc-end-date" />
        </DatePickerComponent>
      )}
      {(owsiDetail.idcdate || owsiDetail.idcendDate) && <WhiteSpace />}
      {owsiDetail.writtenExamTimeExtensions && (
        <>
          <WhiteSpace />
          <CheckboxItem disabled={true} checked={owsiDetail.writtenExamTimeExtensions}>
            <FormattedMessage id="owsi-extensions" />
          </CheckboxItem>
          <WhiteSpace />
        </>
      )}
      {renderQuestion('q1', 'owsi-Q1', q1Options, formData.q1, (value) => updateFormData({ q1: value }))}
      {renderQuestion('q2', 'owsi-Q2', q2Options, formData.q2, (value) => updateFormData({ q2: value }))}
      <Signature
        filePath={'signature'}
        initSignature={owsiDetail.handwrittenSignatureUrl}
        modified={isFormEditable()}
      />
      <WhiteSpace />
      {isFormEditable() && <Agreement changeChecked={setChecked} />}
      <WhiteSpace />
      {isFormEditable() && (
        <AutoRenewCheckbox
          setChecked={setIsAutoRenewChecked}
          checked={isAutoRenewChecked}
          setJump={handleJumpChange}
          jump={isAutoRenewJump}
        />
      )}
      <WhiteSpace size="xl" />
      <OwsiApplicationStatus
        formData={formData}
        owsiDetail={owsiDetail}
        certStatus={checkCertStatus()}
        checkAge={checkAge}
        isAutoRenewJump={isAutoRenewJump}
        agreementChecked={checked}
      />
    </>
  ) : null
}

export default OwsiApplication
